export default function CertificateOutput({ pdfRef, name, data }) {
  return (
    <div
      ref={pdfRef}
      style={{
        position: "absolute",
        left: "-9999px",
        top: 0,
        width: "1600px",
        height: "1240px",
        background: "url('img/kiyg-esports-template-1.jpg') no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        // ...all font sizes and positions scaled up for 1600x1240
        // position: "relative",
        // overflow: "auto",
        fontFamily: "serif",
      }}
    >
      {/* certificate content, font sizes for 1600x1240 */}
      <h4
        style={{
          position: "absolute",
          // top: "52%",
          top: "50%",
          left: "50%",
          // top: "218px",
          // left: "280px",
          transform: "translate(-50%, -50%)",
        //   fontSize: "17px",
          fontSize: "48.57px",
          fontWeight: "bold",
        }}
      >
        {data?.name || name}
      </h4>
      <h6
        style={{
          position: "absolute",
          textAlign: "center",
          // top: "61.5%",
          top: "60.6%",
          // top: "262px",
          left: "62%",
          // left: "347px",
          transform: "translate(0, -50%)",
        //   fontSize: "9px",
          fontSize: "25.71px",
          fontWeight: "bold",
        }}
      >
        {data?.title || "Battlegrounds Mobile India"}
      </h6>
      <h6
        style={{
          position: "absolute",
          textAlign: "center",
          // top: "27.5%",
          top: "26.3%",
          left: "12%",
          transform: "translate(0, -50%)",
        //   fontSize: "8.2px",
          fontSize: "23.43px",
          fontWeight: "bold",
        }}
      >
        {data?.referenceNo || "KIYG25/ES/001"}
      </h6>
    </div>
  );
}
